<template>
<Window id="alert" :btnCancel="false" @Closed="removeSelf" ref="Window">
	<div class="cWarning">
		<span v-html="value"></span>
	</div>
	<button slot="btmBtn" class="functionBtn tra-fast" type="button" @click.stop="hide">{{confirmBtnText}}</button>
	<div v-if="doNotNextTime"><Checkbox :text="getLanguageStr('app61',['下次不再提示'])" class="mr1x" slot="btmBtn"></Checkbox></div>

</Window>
</template>
<script>
import * as lib from "@/util/lib.js"
import {getLanguageStr} from "@/util/language.js"
import Checkbox from "@/components/common/ui/Checkbox.vue";
import Window from '@/components/common/ui/WindowForAlert.vue';

let timer
export default {
	name: 'alert',
	components:{Window,Checkbox},
	props:{
		// title:{
		// 	type: String,
		// 	default:getLanguageStr('plant_detail77','请确认')
		// },
		delay:{
			type: Number,
			default:0
		},
		confirmBtnText:{
			type: String,
			default:getLanguageStr('cmd15','我知道了')
		},
		doNotNextTime:{//下次不再提示,传入保存字段名
			type:String,
			default:""
		}
	},
	data(){
		return {
			msg:'',
			args:[],
			value:''
		}
	},
	methods:{
		getLanguageStr,
		show(options){
			if(timer){
				clearTimeout(timer)
			}
      if (options) this.$refs.Window.show({title:options})
      else  this.$refs.Window.show();
			
			timer = setTimeout(() => {
				// this.hide()
			}, this.delay);
			// setTimeout(()=>{
			// },100);
		},
		hide(option={}){
			this.$refs.Window.hide(option.end);
		},
		removeSelf:function(){
			$(this.$el).remove();
		}
	}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/plugins/notify/Notify.vue